import { useEffect, useRef, useState } from "react";
import FullHeightLayout from "../../components/FullHeightLayout";
import { Button, Card, message, Modal, Space, Table, Tabs, Input } from "antd";
import useWebPost from "../../utils/useWebPost";

let d1 = 0, d2 = 0;
function CheckData() {
    const webPost = useWebPost();
    const [tabKey, setTabKey] = useState('1');
    const [data, setData] = useState([]);
    const [data2, setData2] = useState(null);
    const [conf, setConf] = useState({});
    const [loading, setLoading] = useState(false);

    const loadingRef = useRef();
    const fetchData = async (key) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setLoading(true);
        setData([]);
        try {
            const res = await webPost("checkLyDatas", { key });
            if (res) {
                setData(res);
            }
        } finally {
            loadingRef.current = false;
            setLoading(false);
        }
    }
    useEffect(() => {
        fetchData(tabKey);
    }, [tabKey])
    const columns1 = [
        { title: 'ID', dataIndex: 'id', width: 80 },
        { title: '编号', dataIndex: 'sn', width: 90 },
        { title: '收款金额', dataIndex: 'this_receipt_amount', width: 90 },
        { title: '当前余额', dataIndex: 'left_amount', width: 90 },
        { title: '支出合计', dataIndex: 'total_amount', width: 90 },
        { title: '收支差额', dataIndex: 'tsf', width: 90 },
        { title: '流水合计', dataIndex: 'total_fc', width: 90 },
        {
            title: '操作', dataIndex: 'op', width: 200, render: (_, rs) => {
                return <Space size="middle"><Button type="text" onClick={() => viewD1(rs)}>查看详情</Button><Button type="link" onClick={() => modD1(rs)}>修复错误</Button></Space>
            }
        },
    ]
    const columns2 = [
        { title: 'ID', dataIndex: 'pf_id', width: 80 },
        { title: '金额', dataIndex: 'amount', width: 120 },
        { title: '类型', dataIndex: 'lx', width: 120 }
    ]
    const columns3 = [
        { title: 'ID', dataIndex: 'id', width: 80 },
        { title: '项目编号', dataIndex: 'sn', width: 120 },
        { title: '申请金额', dataIndex: 'amount', width: 120 },
        { title: '审核ID', dataIndex: 'bid', width: 100 },
        { title: '操作', dataIndex: 'op', width: 120, render: (_, rs) => <Button type="link" onClick={() => modDx(rs)}>修复错误</Button> }
    ]
    const viewD1 = async (rs) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setLoading(true);
        d1 = 0;
        d2 = 0;
        try {
            setData2(null);
            const res = await webPost("viewLyDatas", { id: rs.id, key: 1 });
            if (res) {
                setData2(res);
                res.forEach(it => it.lx === '流水记录' ? d2 += Number(it.amount) : d1 += Number(it.amount));
            }
        } finally {
            loadingRef.current = false;
            setLoading(false);
        }
    }
    const modD1 = async (rs) => {
        if (rs.total_amount - rs.total_fc === 0) {
            modfix1([{ id: rs.id, a: 0, b: 0, c: 0 }]);
        } else {
            let inputvalue = '';
            Modal.confirm({
                title: "请输入正确的余额",
                content: (<div>
                    <div>
                        <span>支出合计</span><span style={{ 'fontWeight': 800, 'fontSize': '1.05rem', 'paddingLeft': '12px' }}>{rs.total_amount}</span>
                        <span style={{ width: '20px' }}></span>
                        <span>流水合计</span><span style={{ 'fontWeight': 800, 'fontSize': '1.05rem', 'paddingLeft': '12px' }}>{rs.total_fc}</span>
                    </div>
                    <div><Input onChange={(e) => inputvalue = e.target.value} /></div>
                </div>),
                onOk: (() => {
                    if (Number(inputvalue) > 0) {
                        modfix1([{
                            id: rs.id, a: inputvalue
                        }])
                    } else { message.error('金额必须大于0') }
                }),
            })
        }
    }
    const modDx = async (rs) => {
        modfix1([{ id: rs.id }]);
    }
    const modfix1 = async (params) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setLoading(true);
        try {
            const res = await webPost("fixCwDatas", { data: params, key: tabKey });
            if (res) {
                message.success(`共修复了${res}条记录`);
                setTimeout(() => {
                    fetchData(tabKey);
                }, 50);
            }
        } finally {
            loadingRef.current = false;
            setLoading(false);
        }
    }
    const fixAll = async () => {
        const params = [];
        if (tabKey === '1') {
            data.forEach(rs => {
                if (rs.total_amount - rs.total_fc === 0) {
                    params.push({ id: rs.id, a: 0 });
                }
            })
        } else {
            data.forEach(rs => {
                params.push({ id: rs.id });
            })
        }
        if (params.length > 0) {
            modfix1(params);
        } else {
            message.error("数据为空");
        }
    }
    return (
        <FullHeightLayout
            headerContent={
                <Tabs onChange={(k) => setTabKey(k)}>
                    <Tabs.TabPane tab="检查分流资金问题" key="1"></Tabs.TabPane>
                    <Tabs.TabPane tab="检查收款审核状态" key="2"></Tabs.TabPane>
                    <Tabs.TabPane tab="检查支出审核状态" key="3"></Tabs.TabPane>
                    <Tabs.TabPane tab="检查发票审核状态" key="4"></Tabs.TabPane>
                </Tabs>
            }
        >
            <div><Button onClick={fixAll}>修复所有</Button></div>
            {tabKey === '1' && (
                <Table
                    columns={columns1}
                    dataSource={data}
                    rowKey={(rs, index) => rs['id'] + "_" + tabKey}
                    loading={loading}
                    pagination={false}
                    bordered
                    scroll={{
                        x: 860,
                        y: 'calc(100vh - 300px)',
                    }}
                    tableLayout="fixed"
                />
            )}
            {['2', '3', '4'].includes(tabKey) && (
                <Table
                    columns={columns3}
                    dataSource={data}
                    rowKey={(rs, index) => rs?.bid + "_" + tabKey + "_" + index}
                    loading={loading}
                    pagination={false}
                    bordered
                    scroll={{
                        x: "max-content",
                        y: 'calc(100vh - 340px)',
                    }}
                    tableLayout="fixed"
                />
            )}
            <Modal footer={null} open={data2} onCancel={() => setData2(null)}>
                <Card title={`支出明细，流水记录合计${d2}，其它合计${d1}`}>
                    <Table
                        columns={columns2}
                        dataSource={data2}
                        rowKey={'pf_id'}
                        loading={loading}
                        pagination={false}
                        bordered
                    />

                </Card>
            </Modal>
        </FullHeightLayout>
    )
}
export default CheckData;